export default __webpack_public_path__ + "static/overpass-light-0d2b7fc071b3b8e8c7b898cd4d9f222d.woff2";